import type { AreaCatalog } from '../area';
import type { map as en } from '../en/map';

export const map = {
  'map.page.title': 'Landkarte',
  'map.page.count': { one: '{count} Aufgabe', other: '{count} Aufgaben' },

  'map.canvas.layingOut': 'Das Netz wird angeordnet…',
  'map.canvas.label':
    'Landkarte des Aufgabennetzes. Pfeiltasten verschieben, Plus und Minus zoomen, 0 passt alles ein.',
  'map.canvas.depth': 'Tiefe',
  'map.canvas.foldLevel': 'Eine Ebene einklappen',
  'map.canvas.unfoldLevel': 'Eine Ebene ausklappen',
  'map.canvas.depthAll': 'Alle',
  'map.canvas.auto': 'Auto',
  'map.canvas.autoTitle': 'Die Tiefe wieder dem Zoom überlassen',
  'map.canvas.zoomIn': 'Vergrößern',
  'map.canvas.zoomOut': 'Verkleinern',
  'map.canvas.fit': 'Alles einpassen',
  'map.canvas.reset': 'Ansicht zurücksetzen',
  'map.canvas.empty': 'Keine Aufgabe passt zu diesen Filtern.',

  'map.node.selected': '{title}, ausgewählt',
  'map.node.needs': 'Verantwortlich: {name}',
  'map.node.noRequester': 'verwaist',
  'map.node.noGroups': 'in keiner Gruppe',
  'map.node.group': 'Gruppe',
  'map.node.more': '+{count} weitere',
  'map.node.expand': 'Karte ausklappen',
  'map.node.collapse': 'Karte einklappen',
  'map.node.fold': 'Diesen Teilbaum einklappen',
  'map.node.unfold': {
    one: '{count} verborgene Aufgabe ausklappen',
    other: '{count} verborgene Aufgaben ausklappen',
  },
  'map.node.unfoldDeadlock': {
    one: '{count} verborgene Aufgabe ausklappen, darunter eine gegenseitige Blockade',
    other: '{count} verborgene Aufgaben ausklappen, darunter eine gegenseitige Blockade',
  },
  'map.deadlock': 'gegenseitige Blockade',

  'map.relation.partOf': 'Teil von',
  'map.relation.contains': 'Enthält',
  'map.edge.partOf': 'Teil von',
  'map.edge.dependsOn': 'hängt ab von',
  'map.edge.relatesTo': 'hängt zusammen mit',
  'map.edge.arrowheads': 'Pfeilspitzen',

  'map.inspector.doing': 'Zuständig',
  'map.inspector.needsDoing': 'noch zu vergeben',
  'map.inspector.needs': 'Verantwortlich',
  'map.inspector.nobody': 'niemand',
  'map.inspector.groups': 'Gruppen',
  'map.inspector.partiesOnly': 'nur Beteiligte',
  'map.inspector.containsCount': { one: '{count} Aufgabe', other: '{count} Aufgaben' },
  'map.inspector.waitingOn': 'Wartet auf',
  'map.inspector.blocking': 'Blockiert',
  'map.inspector.hint': 'Klicken zum Öffnen',

  'map.menu.label': 'Aktionen für {title}',
  'map.menu.open': 'Öffnen',
  'map.menu.scopeSubtree': 'Ausschnitt: Teilbaum',
  'map.menu.scopeConnected': 'Ausschnitt: Verbundene',
  'map.hide': 'Ausblenden',
  'map.selection.label': 'Aktionen für die Auswahl',
  'map.selection.count': '{count} ausgewählt',
  'map.selection.clear': 'Auswahl leeren',

  'map.mobile.empty': 'Noch nichts auf der Landkarte.',
  'map.mobile.focused': 'Aufgabe im Fokus',
  'map.mobile.connections': 'Verbindungen',
  'map.mobile.open': '{title} öffnen',
  'map.mobile.contains': 'enthält {count}',
  'map.mobile.deadlockWith': 'gegenseitige Blockade mit',
  'map.mobile.blockedBy': 'blockiert durch',
  'map.mobile.blocks': 'blockiert',
} as const satisfies AreaCatalog<typeof en>;
